import React from 'react';
import { Box } from '@wegroup/design-system';
import useCurrentGroup from '../../../../../hooks/useCurrentGroup';
import { useLocale } from '../../../../../../../../i18n';
import QuestionGroupAssistantQuestion from './QuestionGroupAssistantQuestion';
import useDisplayHomeWrapper from '../../hooks/useDisplayHomeWrapper';

const QuestionGroupHeader: React.FC<React.PropsWithChildren<unknown>> = () => {
  const currentGroup = useCurrentGroup();
  const { userLang } = useLocale();
  const { title, description } = currentGroup || {};
  const isHomeQuestion = useDisplayHomeWrapper();

  return (
    <Box flexShrink={0} w="100%" zIndex="1">
      <QuestionGroupAssistantQuestion
        question={title?.[userLang]}
        description={description?.[userLang]}
        horizontal={isHomeQuestion}
        index={currentGroup?.index}
      />
    </Box>
  );
};

export default QuestionGroupHeader;
